import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import redactBiut, { redactBiutInValue } from '@alltrails/core/utils/redactBiut';

// Set by the inline script in RootLayout (and pages _document) before this module runs.
const ddVersion = window.__AT_DD_VERSION__;

// Google's gtag stub so gtag exists before hydration on every app.
const dataLayer: unknown[] = window.dataLayer || [];
window.dataLayer = dataLayer;
function gtag() {
  // eslint-disable-next-line prefer-rest-params -- Google's stub pushes the Arguments object
  dataLayer.push(arguments);
}
window.gtag = gtag;

// Initialize Bugsnag for client-side error tracking
if (process.env.NEXT_PUBLIC_BUGSNAG_KEY) {
  Bugsnag.start({
    appType: 'client',
    apiKey: process.env.NEXT_PUBLIC_BUGSNAG_KEY,
    appVersion: ddVersion,
    releaseStage: process.env.NEXT_PUBLIC_DEPLOY_NAMESPACE,
    onBreadcrumb: breadcrumb => {
      breadcrumb.message = redactBiut(breadcrumb.message);
      redactBiutInValue(breadcrumb.metadata);
    },
    onError: event => {
      for (const error of event.errors) {
        error.errorMessage = redactBiut(error.errorMessage);
      }

      redactBiutInValue(event.request);

      for (const breadcrumb of event.breadcrumbs) {
        breadcrumb.message = redactBiut(breadcrumb.message);
        redactBiutInValue(breadcrumb.metadata);
      }

      if ('_metadata' in event) {
        redactBiutInValue(event._metadata);
      }
    },
    plugins: [new BugsnagPluginReact()]
  });

  // this is still necessary because we have window.Bugsnag.notify calls in the monorepo
  window.Bugsnag = Bugsnag;
}

window.forceDD_RUMError = function () {
  window.DD_RUM?.addError(new Error('forced DD_RUM error'));
};
